// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserActionsCell} from './UserActionsCell'
// import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
// import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import { UserRoleCell } from './UserRoleCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Rolle' className='min-w-125px' />,
    // accessor: 'role',
    id: 'role',
    Cell: ({...props}) => <UserRoleCell role={props.data[props.row.index].role} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Beigetreten' className='min-w-125px' />
    ),
    id: 'date_joined',
    Cell: ({...props}) => <p>{new Date(props.data[props.row.index].date_joined).toLocaleDateString('de')}</p>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Aktionen' className='text-end min-w-100px' />
    ),
    id: 'actions',
    // Cell: ({...props}) => <p>Test</p>,
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,

  },
]

export {usersColumns}
